import React from 'react';
import { useTranslationText } from 'locale';
import { HorizontalView, VerticalView } from 'vendor-deprecated/Wrapper';
import { SVGIcon } from 'vendor-deprecated/Icon';
import { AppColors } from 'helpers';
import { TextDisplay } from 'vendor-deprecated/Text';

type RateViewProps = {
  editable?: boolean;
  star: number;
  totalRate?: number;
  starSize?: string;
  fontSize?: string;
  showTotal?: boolean;
  onChange?: (rate: number) => void;
};

export const RateView = (props: RateViewProps) => {
  const { translation } = useTranslationText();

  return (
    <VerticalView alignContent={'centerLeft'}>
      <HorizontalView flexWrap="nowrap">
        <HorizontalView
          cursor={props.editable ? 'pointer' : 'auto'}
          onClick={() => {
            props.editable && props.onChange && props.onChange(1);
          }}
        >
          <SVGIcon
            size={props.starSize || '30px'}
            name={'star-fill'}
            color={props.star >= 1 ? AppColors.ORANGE : AppColors.GRAY_LIGHT}
          />
        </HorizontalView>
        <HorizontalView
          cursor={props.editable ? 'pointer' : 'auto'}
          onClick={() => {
            props.editable && props.onChange && props.onChange(2);
          }}
        >
          <SVGIcon
            size={props.starSize || '30px'}
            name={'star-fill'}
            color={props.star >= 2 ? AppColors.ORANGE : AppColors.GRAY_LIGHT}
          />
        </HorizontalView>
        <HorizontalView
          cursor={props.editable ? 'pointer' : 'auto'}
          onClick={() => {
            props.editable && props.onChange && props.onChange(3);
          }}
        >
          <SVGIcon
            size={props.starSize || '30px'}
            name={'star-fill'}
            color={props.star >= 3 ? AppColors.ORANGE : AppColors.GRAY_LIGHT}
          />
        </HorizontalView>
        <HorizontalView
          cursor={props.editable ? 'pointer' : 'auto'}
          onClick={() => {
            props.editable && props.onChange && props.onChange(4);
          }}
        >
          <SVGIcon
            size={props.starSize || '30px'}
            name={'star-fill'}
            color={props.star >= 4 ? AppColors.ORANGE : AppColors.GRAY_LIGHT}
          />
        </HorizontalView>
        <HorizontalView
          cursor={props.editable ? 'pointer' : 'auto'}
          onClick={() => {
            props.editable && props.onChange && props.onChange(5);
          }}
        >
          <SVGIcon
            size={props.starSize || '30px'}
            name={'star-fill'}
            color={props.star >= 5 ? AppColors.ORANGE : AppColors.GRAY_LIGHT}
          />
        </HorizontalView>
        <HorizontalView>
          {/* <TextDisplay size={props.fontSize || '16px'} marginLeft={'10px'}>
            {isFloat(props.star) ? props.star.toFixed(1) : props.star} 
          </TextDisplay> */}
          {!props.editable && props.showTotal && (
            <HorizontalView
              marginLeft={'10px'}
              marginRight={'10px'}
              height={'10px'}
              width={'1px'}
              background={AppColors.GRAY_LIGHT}
            />
          )}
          {!props.editable && props.showTotal && (
            <TextDisplay size={props.fontSize || '16px'}>
              {props.totalRate} {translation('totalReview')}
            </TextDisplay>
          )}
        </HorizontalView>
      </HorizontalView>
    </VerticalView>
  );
};
